import React from "react";
import {connect} from "react-redux";
import {reduxForm, Field, SubmissionError} from "redux-form";
import {compose, withHandlers, lifecycle} from "recompose";
import Button from "react-md/lib/Buttons/Button";
import {forEach, find, sortBy} from "lodash";

import TextField from "../form/TextField";
import AutocompleteField from "../form/AutocompleteField";
import * as Validation from "../form/Validation";

import {foundOrganization, getPackages, getHost, getUserOrganizations} from "../../actions/resourceActions";
import {createMyAtollonInstance, getAvailablePackageListForAtollonInstance, addExistingAtollonInstance} from "../../actions/organizationActions";
import {getUsers} from "../../actions/userActions";
import {setActiveForm} from "../../actions/appActions";

import * as workInProgress from "../../Atollon/messages/UserMessages";
import SelectField from "../form/SelectField";
import {DebugElement} from "../../Atollon/debug";
import {array_utilities} from "../../Atollon/utilities/array_utilities";
import {getInstanceNameLabel} from "../../constants";

/*
let serverChoosesCategory = false;
*/

let addInstanceSuffix = function (loginName, instanceName)
{
    if(instanceName)
    {
        instanceName = '@' + instanceName;
        if (loginName !== 'root' &&  // user is not root (root account does not have instance name)
            loginName.lastIndexOf('@') === -1 && // it has no other instance
            ((loginName.lastIndexOf(instanceName) === -1 || // there is no instance name in the loginName (means it have ot be added)
                loginName.lastIndexOf(instanceName) !== loginName.length-(instanceName).length))) // check if instance name is on the end of login
        { // if does not contains yet
            loginName = loginName + instanceName;
        }
    }

    return loginName;
};


let currentForm_ident = '';

const Form = (inputProps) => {

    let {
        handleSubmit,
        history,
        hostId,
        serverId,
        users,
        getUsers,
        change,
        userOrganization,
        setActiveForm,
        packages,
        productsByOrganization,
        hosts
    } = inputProps;

    let serverCategoryOfSelectedProduct = '';

    console.log( 'AddExisting - react render' );


    const serverIdAsMenuItems = [];
    if (hosts)
    {
        forEach( array_utilities.array_of_structs_locale_sort_by_array_of_field_names( hosts, ['name'] ), host => {
            forEach( array_utilities.array_of_structs_locale_sort_by_array_of_field_names( host.servers, ['name'] ), server => {
                let serverLabelName = `${host.name} - ${server.name}`;
                serverIdAsMenuItems.push({
                    label: serverLabelName,
                    value: server.id
                })
            });
        });
    }

    /*
    let productLocale = [];
    productLocale.push({label: "cz", value: "cz"});
    productLocale.push({label: "en", value: "en"});
    */

    let productName = '';

    return (
        <form onSubmit={handleSubmit} className="form">
            <DebugElement text="/src/components/organizationAddExisting/Form.js"/>
            <Field
                component={TextField}
                label="Název instance"
                name="name"
                validate={[Validation.required]}
            />
            <Field
                component={TextField}
                label={getInstanceNameLabel()}
                name="ident"
                validate={[Validation.required, Validation.isAtollonInstanceIdent]}
                onChange={(e,value)=>{ currentForm_ident = value; }}
            />
            <Field
                component={TextField}
                label="atollonId"
                name="atollonId"
                type="number"
                validate={[Validation.required, Validation.isAtollonInstanceId]}
                onChange={(e,value)=>
                {
                    let atollonId = value;
                    let lastNdigits = (str, n) => {
                        return str.substr( str.length - n, n );
                    };
                    let postfix = lastNdigits( atollonId, 3 );
                    if(value.length <= 3)
                    {
                        postfix = '';
                    }
                    change("postfix", postfix);
                }}
            />
            <Field
                component={TextField}
                label="postfix"
                name="postfix"
                validate={[Validation.required]}
            />
            <Field
                component={SelectField}
                label="server.id"
                name="server.id"
                validate={[Validation.required]}
                menuItems={serverIdAsMenuItems}
            />
            {/* TODO: remove this helper text */}
            <Field
                component={TextField}
                label="lagoon login with @instance"
                name="login"
                validate={[Validation.required]}
                comment="login admin uživatele atollonu který bude použit na vytvoření oauth authority a provázán pro oauth přihlášení s účtem současného uživatele, backend se přihlásí jako {login}@{ident}"
                onBlur={(e,value) => {
                    let loginName = value;
                    let instanceName = currentForm_ident;
                    let newLogin = addInstanceSuffix(loginName,instanceName);
                    change('login', newLogin);
                    e.preventDefault();
                }}
            />
            <Field
                component={TextField}
                label="lagoon password"
                name="password"
                validate={[Validation.required]}
                text=""
            />
            {/*

            <Field
                component={TextField}
                label="serverCategory"
                name="serverCategory"
                validate={[Validation.required]}
            />
            <Field
                component={SelectField}
                menuItems={productLocale}
                label="productLocale"
                name="productLocale"
                validate={[Validation.required]}
            />

            <Field
                component={SelectField}
                menuItems={atollonPackages}
                label="productName"
                name="productName"
                validate={[Validation.required]}
                onChange={ (e,value) => {
                    if (productsByOrganization && productsByOrganization.default)
                    {
                        forEach(productsByOrganization.default, item => {
                            if(item.name == value)
                            {
                                serverCategoryOfSelectedProduct = item.serverCategory;
                            }
                        });
                        change('serverCategory', serverCategoryOfSelectedProduct);
                    }
                }
                }
            />
            */}
            <div className="flex-row flex-right">
                <Button
                    flat
                    label="Zrušit"
                    className="btn"
                    onClick={() => {
                        if (userOrganization) setActiveForm(null);
                        else history.push(`/hosts/${hostId}/${serverId}`);
                    }}
                />
                <Button
                    flat
                    primary
                    label="Založit"
                    type="submit"
                    className="btn btn-primary touchButton-1"
                />
            </div>
        </form>
    );
};

export default compose(
    connect( inputState => {

        let {
            resource: {
                users,
                organizationUsersAdmin,
                organizationUsersOwner,
                organizationUsersUser,
                packages,
                productsByOrganization,
                hosts
            },
            app: {
                role: roleArray,
                role: { 0: roleArray2 }
            }
        } = inputState;

        return {
            users,
            organizationUsersAdmin,
            organizationUsersOwner,
            organizationUsersUser,
            packages,
            hosts,
            productsByOrganization,
            _state: inputState
        }
    }, {
        createMyAtollonInstance,
        getUsers,
        setActiveForm,
        getAvailablePackageListForAtollonInstance,
        getPackages,
        addExistingAtollonInstance,
        getHost,
        getUserOrganizations
    }),
    withHandlers({
        onSubmit: () => async (formData, dispatch, props) => {
            const {hostId, serverId, addExistingAtollonInstance, history, users} = props;

            let createInstanceParameters = formData;
            if (
                await addExistingAtollonInstance(createInstanceParameters)
            ) {
                workInProgress.userMessage_ok("Instance přidána");
            } else {
                workInProgress.userMessage_throwErrorToFieldNamed('billingContact', "Instance nebyla přidána");
            }
        }
    }),
    lifecycle({
        async componentWillMount() {

            const { getHost } = this.props;

            // get all servers for hosts
            // redux will refresh react element after each getHost(host.id)
            {
                await getHost();
                forEach(this.props.hosts, host => {
                    getHost(host.id);
                });
            }
        }
    }),
    reduxForm({form: "organizationAddExistingForm", enableReinitialize: true})
)(Form);



// WEBPACK FOOTER //
// ./src/components/organizationAddExisting/Form.js